import { __assign, __extends } from "tslib";
// Vendor
import React from 'react';
import { View, Animated, Easing } from 'react-native';
import moment from 'moment';
// Custom
import c from '../colors';
import PnmacTextMobile from '../Typography/PnmacTextMobile';
import PnmacScreenContainer from '../ScreenContainer/PnmacScreenContainer';
import PnmacActivityIndicator from '../ActivityIndicator';
var AnimateIn = /** @class */function (_super) {
  __extends(AnimateIn, _super);
  function AnimateIn(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      fadeAnim: new Animated.Value(0),
      slideAnim: new Animated.Value(_this.props.slideFrom)
    };
    return _this;
  }
  AnimateIn.prototype.componentDidMount = function () {
    var animProps = {
      duration: this.props.duration || 3500,
      easing: this.props.easing || Easing.bezier(0.25, 1, .3, 1),
      delay: this.props.delay || 0
    };
    Animated.parallel([Animated.timing(this.state.fadeAnim, __assign(__assign({}, animProps), {
      toValue: 1
    })), Animated.timing(this.state.slideAnim, __assign(__assign({}, animProps), {
      toValue: 0
    }))]).start();
  };
  AnimateIn.prototype.render = function () {
    var _a = this.state,
      fadeAnim = _a.fadeAnim,
      slideAnim = _a.slideAnim;
    return /*#__PURE__*/React.createElement(Animated.View, {
      style: __assign(__assign({}, this.props.style), {
        opacity: this.props.fade ? fadeAnim : 1,
        transform: [{
          translateY: this.props.slideFrom ? slideAnim : 0
        }]
      })
    }, this.props.children);
  };
  return AnimateIn;
}(React.PureComponent);
var getTimeText = function (props) {
  var translations = props.translations;
  var g = null; //return g
  var split_afternoon = 12; //24hr time to split the afternoon
  var split_evening = 17; //24hr time to split the evening
  var currentHour = parseFloat(moment().format("HH"));
  if (currentHour >= split_afternoon && currentHour < split_evening) {
    g = translations.goodAfternoon;
  } else if (currentHour >= split_evening) {
    g = translations.goodEvening;
  } else {
    g = translations.goodMorning;
  }
  return g;
};
var WelcomeLoader = function (props) {
  var _a, _b, _c;
  return /*#__PURE__*/React.createElement(PnmacScreenContainer, {
    loading: false
  }, /*#__PURE__*/React.createElement(View, {
    style: [s.container, props.containerStyles]
  }, /*#__PURE__*/React.createElement(AnimateIn, {
    fade: true,
    slideFrom: 30,
    delay: 1000
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    white: true,
    gilroy: true,
    size: 32
  }, getTimeText(props))), /*#__PURE__*/React.createElement(AnimateIn, {
    slideFrom: 0,
    fade: true,
    delay: 3000,
    duration: 750
  }, /*#__PURE__*/React.createElement(View, {
    style: s.loading
  }, /*#__PURE__*/React.createElement(PnmacActivityIndicator, {
    size: 25,
    color: c.white
  }), /*#__PURE__*/React.createElement(PnmacTextMobile, {
    white: true,
    size: 15,
    style: {
      marginTop: 15,
      width: 240,
      textAlign: 'center'
    }
  }, (_a = props === null || props === void 0 ? void 0 : props.translations) === null || _a === void 0 ? void 0 : _a.retrievingYourInformation))), /*#__PURE__*/React.createElement(AnimateIn, {
    slideFrom: 0,
    fade: true,
    delay: 15000,
    duration: 750
  }, /*#__PURE__*/React.createElement(View, {
    style: s.loadingLong
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    white: true,
    size: 15,
    style: {
      marginTop: 15,
      width: 200,
      textAlign: 'center'
    }
  }, (_b = props === null || props === void 0 ? void 0 : props.translations) === null || _b === void 0 ? void 0 : _b.stillWorkingOnIt))), /*#__PURE__*/React.createElement(AnimateIn, {
    slideFrom: 0,
    fade: true,
    delay: 30000,
    duration: 750
  }, /*#__PURE__*/React.createElement(View, {
    style: s.loadingLong
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    white: true,
    size: 15,
    style: {
      marginTop: 15,
      width: 200,
      textAlign: 'center'
    }
  }, (_c = props === null || props === void 0 ? void 0 : props.translations) === null || _c === void 0 ? void 0 : _c.connectionIsSlow)))));
};
export default WelcomeLoader;
var s = {
  container: {
    flex: 1,
    backgroundColor: c.blue,
    justifyContent: 'center',
    alignItems: 'center'
  },
  loading: {
    opacity: .7,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 60
  },
  loadingLong: {
    opacity: .7,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10
  }
};